var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hideshow),expression:"hideshow"}],staticClass:"open_box",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }